<ng-container *ngIf="costUnitGroupState$ | async as state">

    <div class="cost-unit-group-container mat-elevation-z8">
        <div class="cost-unit-group-table-header">
<!--            <mat-form-field>-->
<!--                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">-->
<!--                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value" (click)="filter.value=''; applyFilter('');">-->
<!--                    <mat-icon>close</mat-icon>-->
<!--                </button>-->
<!--            </mat-form-field>-->

            <button mat-mini-fab
                    color="primary"
                    matTooltip="{{ 'app.page.cost-unit-group.actions.add.label' | translate }}"
                    (click)="onOpenDialog()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="name">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "app.model.cost-unit-group.label" | translate }}</th>
                    <td mat-cell *matCellDef="let data">


                        <button mat-icon-button
                                [style.marginLeft.px]="data.level * 32"
                                (click)="treeControl.toggle(data)">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl.isExpanded(data) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </button>

                        {{data.name}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="edit-button">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" class="actions-column">
                        <button mat-icon-button
                                color="primary"
                                matTooltip="{{ 'app.page.cost-unit-group.actions.edit.label' | translate }}"
                                (click)="onOpenDialog(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button
                                color="warn"
                                matTooltip="{{ 'app.page.cost-unit-group.actions.delete.label' | translate }}"
                                (click)="onDeleteCostUnitGroup(element)"
                                [disabled]="element.assignedContributionMarginLevels !== 0 || element.assignedCostUnits !== 0">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>

                    <ng-container matColumnDef="assignments">
                        <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-unit-group.assignments.label" | translate }}</th>

                        <td mat-cell *matCellDef="let element" style="width: 120px; text-align: center">
                            <div style="display: flex; flex-direction: row; gap: 8px">
                                <button mat-icon-button (click)="onOpenAssignedCostUnitsDialog(element)"
                                        matTooltip="{{ 'app.model.cost-unit-group.assign-cost-units.label' | translate }}">
                                    <mat-icon [matBadge]="element.assignedCostUnits.length" matBadgeSize="small" matBadgeOverlap="false">dinner_dining</mat-icon>
                                </button>

                                <button mat-icon-button (click)="onOpenAssignedContributionMarginLevelsDialog(element)"
                                        matTooltip="{{ 'app.model.cost-unit-group.assign-contribution-margin-levels.label' | translate }}">
                                    <mat-icon [matBadge]="element.assignedContributionMarginLevels" matBadgeSize="small" matBadgeOverlap="false">list</mat-icon>
                                </button>
                            </div>

                        </td>
                    </ng-container>

                </ng-container>
                <tr mat-header-row *matHeaderRowDef="layout.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: layout.columns;"></tr>

            </table>
        </div>
        <mat-paginator [pageSize]="20" [pageSizeOptions]="[20, 50]"></mat-paginator>
    </div>


</ng-container>
